import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from "./pages/EditPage.tsx";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import config from "./config";

export const CodePipelinesLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListCodePipelines) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path=':name'
                element={
                    allowedActions.includes(rbacActions.GetCodePipeline) ? (
                        <EditPage/>
                    ) : (
                        <Navigate to={config.basePath}/>
                    )
                }

            >
            </Route>


        </Routes>
    );
};
